import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_INVOICE_DOWNLOAD_BILL_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetInvoicePDFRequestPayload, GetInvoicePDFResponseResult } from '../types/getBillPdf.types';

export const getInvoicePdf = (builder: BuilderType) =>
  builder.query<GetInvoicePDFResponseResult, GetInvoicePDFRequestPayload>({
    providesTags: ['OutstandingBill'],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_INVOICE_DOWNLOAD_BILL_URL,
    }),

    transformResponse: (response: GenericApiResponse<GetInvoicePDFResponseResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
